/** @jsxImportSource @emotion/react */
import { useSearchParams } from 'react-router-dom'
import Typography from '@mui/material/Typography'
import React, { useState } from 'react'
import TabsNavigation from 'components/TabsNavigation'
import { DescriptionForm, DescriptionPages } from 'components/DescriptionForm'
import { TabsItem } from 'types/tabsItem'
import { ChapterNotesList } from './List'
import * as classes from './styles'

export const QUERY_PARAM = 'tab'

const LIST_TAB = 'List'
const DESCRIPTION_TAB = 'Description'

const TABS: Array<{ id: string; title: string }> = [
  {
    id: LIST_TAB,
    title: 'List',
  },
  {
    id: DESCRIPTION_TAB,
    title: 'Description',
  },
]

export const ChapterNotes = () => {
  const [searchParams, setSearchParams] = useSearchParams()

  const [activeTab, setActiveTab] = useState<TabsItem>(() => {
    const tabId = searchParams.get(QUERY_PARAM)

    return TABS.find(({ id }) => id === tabId) || TABS[0]
  })

  const handleChangeTab = (activeTab: TabsItem) => {
    setSearchParams((prev) => ({
      ...Object.fromEntries(prev.entries()),
      [QUERY_PARAM]: activeTab.id,
    }))
    setActiveTab(activeTab)
  }

  const renderTab = () => {
    switch (activeTab.id) {
      case LIST_TAB:
        return <ChapterNotesList />
      case DESCRIPTION_TAB:
        return <DescriptionForm page={DescriptionPages.ChapterNotes} />
    }
    return <></>
  }

  return (
    <section css={classes.container}>
      <Typography css={classes.header} variant="title3">
        Chapter Notes
      </Typography>

      <TabsNavigation css={classes.tabs} tabs={TABS} value={activeTab} onChange={handleChangeTab} />

      {renderTab()}
    </section>
  )
}
